import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { CTAButtons } from 'components';

import GeneralSettings from './GeneralSettings';
import SaleOptions from './SaleOptions';
import PaymentTenders from './PaymentTenders';
import ProductsSettings from './ProductsSettings';
import CheckoutSettings from './CheckoutSettings';
import POSFunctions from './POSFunctions';
import SaleDocuments from './SaleDocuments';
import StartEndDay from './StartEndDay';
import DBDisplay from './DB&Display';

const subRoutes = [
  GeneralSettings,
  SaleOptions,
  POSFunctions,
  PaymentTenders,
  ProductsSettings,
  CheckoutSettings,
  SaleDocuments,
  StartEndDay,
  DBDisplay,
];

function Content() {
  const navigate = useNavigate();
  const buttons = {
    next: {
      onClick: () => navigate(GeneralSettings.path),
    },
  };
  return (
    <>
      <div className="jumbotron">
        <p>
          Setup various aspects of POS including the visual and behaviour parts:
        </p>
        <ol>
          {subRoutes.map((route) => (
            <li key={route.path}>
              <Link to={`${route.path}`}>{route.title}</Link>
            </li>
          ))}
        </ol>
      </div>
      <CTAButtons buttons={buttons} />
    </>
  );
}

export default {
  title: 'POS Settings',
  path: '/pos-settings',
  component: Content,
  subRoutes,
  rootPath: { name: 'POS Settings' },
};
